import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from "src/environments/environment";
import { Permisos } from "src/app/_models/sesion/permisos";

@Injectable({
  providedIn: 'root'
})
export class PermisosService {
  baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) { }
  getPermisos(usuario) {
    return this.http.get(`${this.baseUrl}/login/getAllPermisos.php?codinter=${usuario}`);
  }

  getDatos(usuario) {
    return this.http.get(`${this.baseUrl}/login/datosUsuario.php?codinter=${usuario}`);
  }
}